<div class="item-story h-full overflow-auto p-4">
  <div *ngIf="isLoading" class="text-sm text-muted">Loading the item's story…</div>

  <div *ngIf="loadError" class="text-sm" style="color: var(--p-red-500, #ef4444);">
    {{ loadError }}
  </div>

  <div *ngIf="!isLoading && !loadError && events.length === 0" class="text-sm text-muted">
    No history recorded for this item yet.
  </div>

  <ol *ngIf="!isLoading && !loadError && events.length > 0" class="item-story-timeline">
    <li
      *ngFor="let e of events; let i = index"
      class="item-story-event"
      [class.item-story-event--anomaly]="e.isAnomaly"
    >
      <div class="item-story-event__marker" aria-hidden="true"></div>
      <div class="item-story-event__body">
        <div class="item-story-event__meta">
          <span class="item-story-event__timestamp">
            {{ e.timestamp | date : "MMM d, y, h:mm a" }}
          </span>
          <span class="item-story-event__actor">{{ e.actor }}</span>
        </div>
        <div class="item-story-event__headline">{{ e.headline }}</div>
        <div class="item-story-event__detail">{{ e.detail }}</div>
        <div *ngIf="e.anomalyReason" class="item-story-event__anomaly-reason">
          {{ e.anomalyReason }}
        </div>
      </div>
    </li>
  </ol>
</div>
